// extracted by mini-css-extract-plugin
export var header = "_t2-1";
export var maskBottom = "_t2-6";
export var maskMiddle = "_t2-7";
export var maskTop = "_t2-5";
export var root = "_t2-0";
export var scrollDownButton = "_t2-3";
export var scrollDownButtonHidden = "_t2-4";
export var viewport = "_t2-2";